


<template>
    <div class="flower-page">
        <div class="filters-abetca">
            <span v-for="letter in alphabet" :class="currentLetter == letter ? 'active' : ''"
                  @click="getData(letter)">{{letter}}</span>
        </div>
        <div class="row row-gap">
            <div v-if="items.length > 0" v-for="(item, key) in items"
                 :key="'item_' + key"
                 class="col-6 col-md-3 col-lg-2">
                <div class="gallery-item">
                    <div class="h-100">
                        <div v-if="watermark" class="watermark">
                            <img src="/local-images/water_mark.jpg" alt="">
                        </div>
                        <img :src="item.files[0].url" :alt="item.files[0].description"
                             @click="setCurrentImg(key)">
                    </div>
                    <span class="block-name">
                        {{item.name}}
                    </span>
                </div>

            </div>
        </div>

        <gallery-modal v-if="isShowModal"
                       :img="currentImg.files[0].url"
                       :name="currentImg.name"
                       :watermark="watermark"
                       @close="isShowModal = false"
                       @prev="prev"
                       @next="next"></gallery-modal>
    </div>
</template>

<script>
    import GalleryModal from "../elements/GalleryModal";

    export default {
        name: 'distillation-catalog',
        components: {
            GalleryModal,
        },
        props: {
            id: {
                required: true,
            },
            watermark: {
                required: false,
            },
        },
        data() {
            return {
                Lang,
                alphabet,
                defaultLanguage,
                items: [],
                key: 0,
                currentImg: '',
                isShowModal: false,
                length: 0,
                currentLetter: '',
            }
        },
        methods: {
            getData(letter = null) {
                this.currentLetter = letter;
                let prefix = Lang.locale === defaultLanguage ? '' : '/' + Lang.locale;
                axios.post(prefix + '/get-distillations', {
                    id: this.id,
                    char: letter
                }).then(res => {
                    this.items = res.data;
                    this.length = res.data.length;
                })
            },
            setCurrentImg(key) {
                this.key = key;
                this.currentImg = this.items[key];
                this.isShowModal = true;
            },
            prev() {
                if (this.key > 0) {
                    this.key = this.key - 1;
                } else {
                    this.key = this.length - 1;
                }
                this.currentImg = this.items[this.key];
            },
            next() {
                if (this.key < this.length - 1) {
                    this.key = this.key + 1;
                } else {
                    this.key = 0;
                }
                this.currentImg = this.items[this.key];
            }
        },
        mounted() {
            this.getData();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/catalog/DistillationCatalog.vue